<template>
  <ConfirmationDialog :value="open" submitText="Send Trustpilot" @confirmed="send" @close="cancel" :loading="getSendTrustpilotReviewEmailLoading">
    
    <template #title>Send Trustpilot review</template>

    <template #text>Are you sure you would like to send a Trustpilot review?</template>

  </ConfirmationDialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import ConfirmationDialog from '@/components/Globals/ConfirmationDialog';

  export default {
    components: { ConfirmationDialog },

    props: {
      open: {
        type: Boolean,
        value: false
      }
    },

    computed: {
      ...mapGetters('trustpilotEmail', ['getSendTrustpilotReviewEmailLoading', 'getSendTrustpilotReviewEmailError']),
      ...mapGetters('products', ['getCurrentProduct'])
    },

    methods: {
      ...mapActions('trustpilotEmail', ['sendTrustpilotReviewEmail']),

      async send() {
        await this.sendTrustpilotReviewEmail(this.getCurrentProduct.account_id);

        if (!this.getSendTrustpilotReviewEmailError) {
          this.cancel();
          setTimeout(()=>{
            window.location.reload();
          }, 500);    
        }
      },

      cancel() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>